import React from 'react';
import { Phone, MapPin, Mail, Clock, Facebook, Instagram } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

const Footer = () => {
    const { settings, loading } = useSettings();

    const footerData = loading ? {
        siteName: 'ANKARA MERKEZ FAR',
        siteDescription: 'İçi kararan, güneşten solan ve üzeri çizilmiş otomobil, kamyonet, otobüs ve motorsiklet FAR & STOP\'larınızı yeni gibi yapıyoruz.',
        address: '',
        city: 'Ankara',
        phone: '',
        phone2: '',
        email: '',
        workingHours: 'Pazartesi - Cumartesi: 09:00 - 19:00',
        facebook: '',
        instagram: ''
    } : {
        siteName: settings.siteName || 'ANKARA MERKEZ FAR',
        siteDescription: settings.siteDescription || 'İçi kararan, güneşten solan ve üzeri çizilmiş otomobil, kamyonet, otobüs ve motorsiklet FAR & STOP\'larınızı yeni gibi yapıyoruz.',
        address: settings.address || '',
        city: settings.city || 'Ankara',
        phone: settings.phone || '',
        phone2: settings.phone2 || '',
        email: settings.email || '',
        workingHours: settings.workingHours || 'Pazartesi - Cumartesi: 09:00 - 19:00',
        facebook: settings.facebook || '',
        instagram: settings.instagram || ''
    };

    // Parse working hours
    const parseWorkingHours = (hours) => {
        if (!hours) return { days: 'Pazartesi - Cumartesi', time: '09:00 - 19:00' };
        const parts = hours.split(':');
        if (parts.length >= 2) {
            return {
                days: parts[0].trim(),
                time: parts.slice(1).join(':').trim()
            };
        }
        return { days: hours, time: '' };
    };

    const { days, time } = parseWorkingHours(footerData.workingHours);

    return (
        <footer className="bg-gray-900 text-white">
            <div className="container mx-auto px-4 py-12">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Company Info */}
                    <div>
                        <h3 className="text-xl font-bold mb-4">{footerData.siteName}</h3>
                        <p className="text-gray-400 mb-4">
                            {footerData.siteDescription}
                        </p>
                        <div className="flex space-x-4">
                            {footerData.facebook && (
                                <a
                                    href={footerData.facebook}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500 hover:text-blue-400 transition-colors"
                                    aria-label="Facebook sayfamızı ziyaret edin"
                                >
                                    <Facebook size={24} aria-hidden="true" />
                                </a>
                            )}
                            {footerData.instagram && (
                                <a
                                    href={footerData.instagram}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-pink-500 hover:text-pink-400 transition-colors"
                                    aria-label="Instagram sayfamızı ziyaret edin"
                                >
                                    <Instagram size={24} aria-hidden="true" />
                                </a>
                            )}
                        </div>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-xl font-bold mb-4">İletişim Bilgileri</h3>
                        <div className="space-y-3">
                            {footerData.address && (
                                <div className="flex items-start space-x-3">
                                    <MapPin className="text-blue-500 flex-shrink-0 mt-1" size={20} />
                                    <p className="text-gray-400">
                                        {footerData.address}<br />
                                        {footerData.city}
                                    </p>
                                </div>
                            )}
                            {footerData.phone && (
                                <div className="flex items-center space-x-3">
                                    <Phone className="text-blue-500 flex-shrink-0" size={20} />
                                    <a href={`tel:${footerData.phone}`} className="text-gray-400 hover:text-white transition-colors">
                                        {footerData.phone}
                                    </a>
                                </div>
                            )}
                            {footerData.phone2 && (
                                <div className="flex items-center space-x-3">
                                    <Phone className="text-blue-500 flex-shrink-0" size={20} />
                                    <a href={`tel:${footerData.phone2}`} className="text-gray-400 hover:text-white transition-colors">
                                        {footerData.phone2}
                                    </a>
                                </div>
                            )}
                            {footerData.email && (
                                <div className="flex items-center space-x-3">
                                    <Mail className="text-blue-500 flex-shrink-0" size={20} />
                                    <a href={`mailto:${footerData.email}`} className="text-gray-400 hover:text-white transition-colors">
                                        {footerData.email}
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Working Hours */}
                    <div>
                        <h3 className="text-xl font-bold mb-4">Çalışma Saatleri</h3>
                        <div className="space-y-2">
                            <div className="flex items-center space-x-3">
                                <Clock className="text-blue-500 flex-shrink-0" size={20} />
                                <div className="text-gray-400">
                                    <p>{days}</p>
                                    <p className="font-semibold text-white">{time}</p>
                                </div>
                            </div>
                            <div className="text-gray-400 mt-3">
                                <p>Pazar</p>
                                <p className="font-semibold text-white">Kapalı</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
                    <p>&copy; {new Date().getFullYear()} {footerData.siteName}. Tüm hakları saklıdır.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
